import { Api } from "../MainService/api";
import { ErrorKind } from "../MainService/apiProblem";

export class SttTtsApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  /**
   * Gets a Hume API access token from the backend
   */
  async getHumeToken() {
    try {
      const response = await this.api.apisauce.get<{ token: string }>(
        `/api/stt-tts/hume-token`
      );

      let data = await this.api.getResponse(response);
      return data;
    } catch (e) {
      console.error("Error getting Hume token:", e);
      return {
        kind: ErrorKind.BAD_DATA_ERROR,
        errors: "Failed to get Hume token",
      };
    }
  }

  /**
   * Gets an OpenAI token for real-time transcription
   */
  async getOpenAIToken() {
    try {
      const response = await this.api.apisauce.get<{ token: string }>(
        '/api/stt-tts/openai-token'
      );
      
      const data = await this.api.getResponse(response);
      return data;
    } catch (e) {
      console.error('Error getting OpenAI token:', e);
      return {
        kind: 'error',
        errors: 'Failed to get OpenAI token',
      };
    }
  }

  /**
   * Transcribes audio by sending it to the backend
   * @param audioBlob The audio blob to transcribe
   */
  async transcribeAudio(
    audioBlob: Blob
  ): Promise<{ kind: string; data?: { text: string }; errors?: string }> {
    try {
      const formData = new FormData();
      const file = new File([audioBlob], "recording.webm", {
        type: "audio/webm",
      });
      formData.append("audio_file", file);

      const response = await this.api.apisauce.post<{ text: string }>(
        "/api/stt-tts/transcribe",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      let data = await this.api.getResponse(response);
      return data;
    } catch (e) {
      console.error("Error transcribing audio:", e);
      return {
        kind: ErrorKind.BAD_DATA_ERROR,
        errors: "Failed to transcribe audio",
      };
    }
  }
}
